export const MAX_DRAWER_DEPTH = 3

export const DRAWER_ENTITIES = {
  CONTROL: 'control' as const,
  DOCUMENT: 'document' as const,
  EVIDENCE: 'evidence' as const,
  TASK: 'task' as const,
  EMPLOYEE: 'employee' as const,
} as const

export type IDrawerEntity = (typeof DRAWER_ENTITIES)[keyof typeof DRAWER_ENTITIES]

// `?drawer=task.45&drawer=document.123`: the open drawers, first one first (`useDrawerReturnUrl`).
export const DRAWER_URL_PARAM = 'drawer'
export const DRAWER_URL_SEPARATOR = '.'
